// dashboard/patientList/PatientSection.js
// Collapsible red/yellow/green severity grouping of PetCards. Extracted
// from App.js (2026-08-12 split).

import { useState } from 'react';
import { c, severityColor, severityBg } from '../constants';
import PetCard from './PetCard';

export default function PatientSection({ title, severity, petGroups, onSelect, onDismissAlert, onReactivateAlert, onPrintSummary, selectedPatient, defaultOpen, useLbs, freezeCutoff, isInCatchUpWindow, recoveryThresholds, vets, canClinical, onReassignDoctor, onAssignCondition }) {
  const [open, setOpen] = useState(defaultOpen);
  const color = severityColor(severity);

  if (!petGroups.length) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: 8, width: '100%',
          background: 'none', border: 'none', cursor: 'pointer', padding: '10px 0', textAlign: 'left',
        }}
      >
        <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color }} />
        <span style={{ fontSize: 12, fontWeight: 700, color: c.slate, textTransform: 'uppercase', letterSpacing: 0.7 }}>
          {title}
        </span>
        <span style={{ fontSize: 12, fontWeight: 700, color, backgroundColor: severityBg(severity), padding: '1px 8px', borderRadius: 10 }}>
          {petGroups.length}
        </span>
        <span style={{ marginLeft: 'auto', fontSize: 11, color: c.textSoft }}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div>
          {petGroups.map(pg => (
            <PetCard
              key={pg.pet.id}
              petGroup={pg}
              onSelect={onSelect}
              onDismissAlert={onDismissAlert}
              onReactivateAlert={onReactivateAlert}
              onPrintSummary={onPrintSummary}
              recoveryThresholds={recoveryThresholds}
              selectedPatient={selectedPatient}
              useLbs={useLbs}
              freezeCutoff={freezeCutoff}
              isInCatchUpWindow={isInCatchUpWindow}
              vets={vets}
              canClinical={canClinical}
              onReassignDoctor={onReassignDoctor}
              onAssignCondition={onAssignCondition}
            />
          ))}
        </div>
      )}
    </div>
  );
}
